export function attemptsSelectors(state) {
  return state.attempts;
}